module.exports = __webpack_public_path__ + "9ae3709d644c8df5546e96d0eddc99e1.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/PfDinTextCondProBold.ttf
// module id = 51
// module chunks = 0